import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LinkPreviewDTO } from '../../../../shared/LinkPreviewDTO';
import { config } from '../../../core';

const baseQuery = fetchBaseQuery({
  baseUrl: new URL(`${config.api.prefix}`, config.api.origin).href,
  prepareHeaders: (headers) => {
    headers.set('Authorization', `Bearer ${localStorage.getItem('token') ?? sessionStorage.getItem('token')}`);
    return headers;
  },
});

// Define a service using a base URL and expected endpoints
export const linkPreviewApi = createApi({
  reducerPath: 'LINK_PREVIEW',
  baseQuery,
  endpoints: (builder) => ({
    getLinkPreview: builder.mutation<LinkPreviewDTO, string>({
      query: (link) => ({
        url: '/link-preview',
        method: 'POST',
        body: { link },
      }),
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetLinkPreviewMutation,
} = linkPreviewApi;
